import { OTHER_MUNICIPAL_BUILDINGS_SUBSUBSECTOR_ABBREVIATION, OTHER_MUNICIPAL_BUILDINGS_SUBSUBSECTOR_ID, } from "../bisko/constants";
import { RETROFIT_BUILDING_TYPE } from "./retrofit-building-type";
export const OTHER_MUNICIPAL_BUILDING_ENVELOPE_RETROFIT_PROFILE = {
    slug: "other-municipal-building-envelope-retrofit",
    subsubsectorId: OTHER_MUNICIPAL_BUILDINGS_SUBSUBSECTOR_ID,
    subsubsectorAbbreviation: OTHER_MUNICIPAL_BUILDINGS_SUBSUBSECTOR_ABBREVIATION,
    defaultFloorAreaSquareMetreByBuildingType: { [RETROFIT_BUILDING_TYPE.SPORTS_HALL]: 1215 },
    usefulHeatOutputKwhPerSquareMetre: {
        UNRENOVATED_MEAN: 346.2,
        VERY_HIGH: 469.9,
        HIGH: 365.9,
        MEDIUM: 202.7,
        LOW: 107.7,
        VERY_LOW: 64.3,
    },
    canClaimWholeNodeConsumption: false,
};
